import React, { useContext, useEffect, useRef } from 'react'

import { useSelector } from 'react-redux'

import { InternshipsManagerContext } from '../../../Context/InternshipsManager/InternshipsManagerProvider'
import { getInternshipProvider } from './utils/utils'
import { getInternshipLine } from './utils/componentGetters'
import { COLUMNS_INFO_COUNT, DEFAULT_NUMBER_OF_WEEKS } from './utils/constants'
import AutonomousInternshipFormModal from '../../../Providers/Forms/InternshipForm/AutonomousInternshipFormModal'
import { InternshipProperties } from '../../../utils/entities/internship'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { InstitutionContext } from '../../../Providers/InstitutionProvider'
import { isObject } from '../../../utils'

import '../../../assets/internships-manager.scss'

const KEYS_TO_VALIDATE = [
  InternshipProperties.SCHOOL,
  InternshipProperties.START_DATE,
  InternshipProperties.END_DATE,
  InternshipProperties.SECTION,
  InternshipProperties.SECTOR,
  InternshipProperties.INSTITUTION
]

const NO_INTERNSHIPS_TEXT = 'There is no internship to show for these dates.'

const InternshipsTableBody = ({ loading }) => {
  const {
    user, highlightedIndexes, internships, quotas, refreshInternships,
    refreshQuotas, onEarlyStartDate, onLineHover
  } = useContext(InternshipsManagerContext)
  const ic = useContext(InstitutionContext)

  const ordonnedSectors = isObject(ic) ? ic.sectorsOrderByName : []

  const t = useSelector(selectTranslate)

  const { Provider, context } = getInternshipProvider(user?.context)
  const InternshipLine = getInternshipLine(user.context)
  const timer = useRef(null)

  useEffect(() => {
    return () => {
      clearTimeout(timer.current)
    }
  }, [])

  const handleLineHover = indexes => {
    if (timer.current) {
      clearTimeout(timer.current)
    }

    if (highlightedIndexes === null || indexes.startIndex !== highlightedIndexes.startIndex || indexes.lastIndex !== highlightedIndexes.lastIndex) {
      timer.current = setTimeout(() => {
        onLineHover(indexes)
      }, 100)
    }
  }

  return (
    <tbody>
      <AutonomousInternshipFormModal keysToValidate={KEYS_TO_VALIDATE} sectors={ordonnedSectors}>
        {!loading && internships.length > 0 && Provider &&
        internships.map((i, index) => {
          return (
            <Provider
              key={`internship-${index}`}
              internship={i}
              refreshInternships={refreshInternships}
              refreshQuotas={refreshQuotas}
              onEarlyStartDate={onEarlyStartDate}
              quotas={quotas[i.id]}
            >
              <InternshipLine internshipContext={context} onLineHover={handleLineHover} />
            </Provider>
          )
        })}
      </AutonomousInternshipFormModal>
      {!loading && internships.length === 0 &&
        <tr>
          <td colSpan={COLUMNS_INFO_COUNT + DEFAULT_NUMBER_OF_WEEKS}>
            {t(NO_INTERNSHIPS_TEXT)}
          </td>
        </tr>}
      {loading && (
        <tr>
          <td id='loading-td'>
            <div>
              <div className='table-loading-ring' />
            </div>
          </td>
        </tr>
      )}
    </tbody>
  )
}

export default InternshipsTableBody
